<script setup lang="ts">
</script>
<template>
  <!-- <RouterView /> -->
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<style lang="less">

</style>
